module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_50_100.eb6a75dd.png";